import { getTimezoneName } from '@calendly/timezone-tools'
import { DetailsItem as Item } from '@calendly/booking-kit'
import { TimezoneIcon } from '@calendly/ui/components/icons'

export default ({ value }) => (
  <Item>
    <TimezoneIcon data-id="details-item-icon" spacingRight={8} size="large" />
    {getTimezoneName(value)}
  </Item>
)
